import { ActivePageAction } from "../../interfaces/ActivePage"
import { UPDATE_ACTIVE_PAGE } from "./types"

export function updatePageTitle(pageName: string = "") {
	const action: ActivePageAction = {
		type: UPDATE_ACTIVE_PAGE,
		title: pageName,
	}
	return action;
}